export const HOME = {
    GetMainSummary: 'Services/General/HomeMainService.svc/GetMainSummary',
    GetLastestNews: 'Services/BaseServices/NewsService.svc/GetLastestNews',
    FindVWSimplifiedPaged: 'Services/Workshop/RepairOrderService.svc/FindVWSimplifiedPaged',
    GetDeliveryRepairOrdersForToday: 'Services/General/HomeMainService.svc/GetDeliveryRepairOrdersForToday',
    FindAppointmentCarRegistryInDates: 'Services/General/AppointmentsService.svc/FindAppointmentCarRegistryInDates',
    FindAppointmentRegistryInDates: 'Services/General/AppointmentsService.svc/FindAppointmentRegistryInDates',
    FindNotificationType: 'Services/BaseServices/NotificationAlertsService.svc/FindNotificationType',
    FindNotificationAlerts: 'Services/BaseServices/NotificationAlertsService.svc/FindNotificationAlerts',
    UpdateNotificationAlerts: 'Services/BaseServices/NotificationAlertsService.svc/Proccess',
    GetNotificationsSummary: 'Services/General/HomeMainService.svc/GetNotificationsSummary'
}


